import { css } from "@emotion/react";

const RetriableError = ({ reload }: { reload: () => void }) => {
  return (
    <div css={rootStyle} onClick={reload}>
      エラーが発生しました。再度タップ・クリックして読み込んでください
    </div>
  );
};

const rootStyle = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: center;
  justify-content: center;
`;

export default RetriableError;
